// in src/posts.js
import React, { cloneElement } from 'react';
import { connect } from 'react-redux';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  RefreshButton,
  ReferenceInput,
  SelectInput,
  Filter,
  Responsive,
  SimpleList,
  translate,
  resolveBrowserLocale,
  FunctionField,
  TextInput
  //Edit,
  //SimpleForm,
  //EditButton
} from 'react-admin';

// import {
//   editContributionTime
// } from '../contributions/contributionActions';

import {
  Card,
  CardActions,
  CardContent,
  CardHeader
  // Button
} from '@material-ui/core';

import { GetDuration } from '../methods';
import ApproveButton from '../contributions/ApproveButton';
import DeleteButton from '../contributions/DeleteButton';
// import { PageTitle } from './common';
import { Title } from '../components/Title';

import EditableContributionField from '../contributions/EditableContributionField';

import DoneIcon from '@material-ui/icons/Done';
import PendingIcon from '@material-ui/icons/TouchApp';
import UnknownIcon from '@material-ui/icons/Update';
import RejectedIcon from '@material-ui/icons/Clear';
import { Pagination } from 'react-admin';

const PostPagination = props => (
  <Pagination rowsPerPageOptions={[]} {...props} />
);
const paginationContributions = 50;

const getDuration = new GetDuration();

const ContributionsFilter = props => {
  const { translate } = props;
  return (
    <Filter {...props}>
      {/* <TextInput label="Search by users" source="users" alwaysOn /> */}
      <TextInput label="Rechercher mission" source="searchQuery" alwaysOn />

      <ReferenceInput
        label={translate('resources.missions.name', 2)}
        source="missionsId"
        reference="missions"
        sort={{ field: 'title', order: 'ASC' }}
        allowEmpty
      >
        <SelectInput optionText="title" />
      </ReferenceInput>

      <ReferenceInput
        label={translate('resources.users.name', 2)}
        source="userId"
        reference="users"
        sort={{ field: 'name', order: 'ASC' }}
        allowEmpty
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
    </Filter>
  );
};

const ContributionsListActions = ({
  resource,
  filters,
  showFilter,
  displayedFilters,
  filterValues
}) => (
  <CardActions>
    {/* <FilterButton /> */}
    {filters &&
      cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button'
      })}
    <RefreshButton />
  </CardActions>
);

const TotalContributions = ({ contributions, style }) => (
  <div style={style}>{getDuration.getAllDuration(contributions)}</div>
);

let ContributionsComponent = props => {
  const { ids, data, basePath, locales, translate, roleLevel, ...rest } = props;

  let filteredContribs = [];
  if (ids) {
    filteredContribs = Object.values(ids).map(id => data[id]);
  }

  return (
    <Responsive
      small={
        <Card
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%'
          }}
        >
          <CardHeader
            style={{
              textAlign: 'center'
            }}
            subheader={translate('contributions.total_duration')}
            title={
              <TotalContributions
                contributions={filteredContribs}
                style={{
                  fontFamily: 'Helvetica Neue'
                }}
              />
            }
          />

          <CardContent
            style={{
              width: '100%',
              display: 'flex',
              marginLeft: 65
            }}
          >
            <div
              style={{
                //width: '100%',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 10
                }}
              >
                <DoneIcon
                  style={{
                    size: 5,
                    color: 'green',
                    border: '2px solid green',
                    borderRadius: '50%',
                    padding: 5,
                    boxShadow: '1px 1px 5px grey',
                    marginRight: 10
                  }}
                />
                <span>{translate('contributions.approved')}</span>
              </p>
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 10
                }}
              >
                <PendingIcon
                  style={{
                    color: 'orange',
                    border: '2px solid orange',
                    borderRadius: '30%',
                    padding: 5,
                    boxShadow: '2px 2px 5px grey',
                    marginRight: 10
                  }}
                />
                {translate('contributions.pending')}
              </p>
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 10
                }}
              >
                <UnknownIcon
                  style={{
                    color: 'grey',
                    border: '2px solid grey',
                    borderRadius: '30%',
                    padding: 5,
                    boxShadow: '2px 2px 5px grey',
                    marginRight: 10
                  }}
                />
                <span>{translate('contributions.not_finished')}</span>
              </p>
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 10
                }}
              >
                <RejectedIcon
                  style={{
                    color: 'red',
                    border: '2px solid red',
                    borderRadius: '30%',
                    padding: 5,
                    boxShadow: '2px 2px 5px grey',
                    marginRight: 10
                  }}
                />
                <span>{translate('contributions.rejected')}</span>
              </p>
            </div>
          </CardContent>

          <CardContent style={{ width: '100%' }}>
            <SimpleList
              ids={ids}
              data={data}
              onToggleItem={() => {}}
              linkType={false}
              {...rest}
              resource="contributions"
              total={ids.length}
              leftIcon={record => (
                <ApproveButton
                  translate={translate}
                  missionId={data.id}
                  record={record}
                  label="validate"
                  roleLevel={roleLevel}
                />
              )}
              primaryText={record => (
                <span
                  style={{
                    display: 'flex',
                    flexDirection: 'row'
                  }}
                >
                  {/* {`${translate('contributions.contributors', 1)}: `} */}
                  <ReferenceField
                    label="users"
                    source="userId"
                    reference="users"
                    basePath="/users"
                    record={record}
                    linkType="show"
                    allowEmpty
                  >
                    <TextField source="name" />
                  </ReferenceField>
                </span>
              )}
              secondaryText={record => (
                <span>
                  <span
                    style={{
                      display: 'flex',
                      flexDirection: 'row'
                    }}
                  >
                    {`${translate('resources.missions.name', 1)}:`}
                    <ReferenceField
                      record={record}
                      source="missionId"
                      reference="missions"
                      basePath="/missions"
                      sortable={false}
                      linkType="show"
                      allowEmpty
                    >
                      <TextField source="title" />
                    </ReferenceField>
                  </span>
                  {record.start && (
                    <span
                      style={{
                        display: 'flex',
                        flexDirection: 'row'
                      }}
                    >
                      {`${translate('resources.contributions.fields.start')}: `}
                      <DateField
                        source="start"
                        sortable={false}
                        locales={locales}
                        record={record}
                        options={{
                          day: 'numeric',
                          year: 'numeric',
                          month: 'numeric',
                          hour: 'numeric',
                          minute: 'numeric'
                        }}
                      />
                    </span>
                  )}
                  <EditableContributionField
                    contribution={record}
                    translate={translate}
                    roleLevel={roleLevel}
                  />
                </span>
              )}
              // tertiaryText={record => (
              //   <FunctionField
              //     label="duration"
              //     record={record}
              //     render={contribution => (
              //       <EditableContributionField
              //         contribution={contribution}
              //         translate={translate}
              //         roleLevel={roleLevel}
              //       />
              //     )}
              //     // render={contribution =>
              //     //   !contribution.start
              //     //     ? translate('contributions.not_started')
              //     //     : !contribution.end
              //     //       ? translate('contributions.not_finished')
              //     //       : getDuration.getOneDuration(
              //     //           contribution.start,
              //     //           contribution.end
              //     //         )
              //     // }
              //   />
              // )}
              rightIcon={record => (
                <DeleteButton
                  missionId={data.id}
                  record={record}
                  label="validate"
                  roleLevel={roleLevel}
                />
              )}
            />
          </CardContent>
        </Card>
      }
      medium={
        <Card
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <CardContent
            style={{
              width: '100%',
              display: 'flex'
            }}
          >
            <div
              style={{
                //width: '100%',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 10
                }}
              >
                <DoneIcon
                  style={{
                    size: 5,
                    color: 'green',
                    border: '2px solid green',
                    borderRadius: '50%',
                    padding: 5,
                    boxShadow: '1px 1px 5px grey',
                    marginRight: 10
                  }}
                />
                <span>{translate('contributions.approved')}</span>
              </p>
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 10
                }}
              >
                <PendingIcon
                  style={{
                    color: 'orange',
                    border: '2px solid orange',
                    borderRadius: '30%',
                    padding: 5,
                    boxShadow: '2px 2px 5px grey',
                    marginRight: 10
                  }}
                />
                {translate('contributions.pending')}
              </p>
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 10
                }}
              >
                <UnknownIcon
                  style={{
                    color: 'grey',
                    border: '2px solid grey',
                    borderRadius: '30%',
                    padding: 5,
                    boxShadow: '2px 2px 5px grey',
                    marginRight: 10
                  }}
                />
                <span>{translate('contributions.not_finished')}</span>
              </p>
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 10
                }}
              >
                <RejectedIcon
                  style={{
                    color: 'red',
                    border: '2px solid red',
                    borderRadius: '30%',
                    padding: 5,
                    boxShadow: '2px 2px 5px grey',
                    marginRight: 10
                  }}
                />
                <span>{translate('contributions.rejected')}</span>
              </p>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                alignSelf: 'center',
                width: '100%'
              }}
            >
              <h2 style={{ marginBottom: 0 }}>
                <TotalContributions
                  contributions={filteredContribs}
                  style={{
                    fontFamily: 'Helvetica Neue'
                  }}
                />
              </h2>
              <p>{translate('contributions.total_duration')}</p>
            </div>
          </CardContent>
          <CardContent style={{ width: '100%' }}>
            <Datagrid {...props}>
              <ApproveButton
                translate={translate}
                addLabel={false}
                roleLevel={roleLevel}
              />
              <ReferenceField
                label={translate('contributions.contributors', 1)}
                source="userId"
                reference="users"
                basePath="/users"
                sortable={false}
                linkType="show"
                allowEmpty
              >
                <TextField source="name" />
              </ReferenceField>
              <ReferenceField
                label={translate('resources.missions.name', 1)}
                source="missionId"
                reference="missions"
                basePath="/missions"
                // sortable={false}
                linkType="show"
                allowEmpty
              >
                <TextField source="title" />
              </ReferenceField>
              <DateField
                source="start"
                sortable={false}
                locales={locales}
                options={{
                  day: 'numeric',
                  year: 'numeric',
                  month: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric'
                }}
              />

              <FunctionField
                label="duration"
                render={contribution => (
                  <EditableContributionField
                    roleLevel={roleLevel}
                    contribution={contribution}
                    translate={translate}
                  />
                )}
              />
              <DeleteButton roleLevel={roleLevel} />
            </Datagrid>
          </CardContent>
        </Card>
      }
    />
  );
};

let ContributionsList = props => {
  const {
    translate,
    hasList,
    hasEdit,
    hasShow,
    permissions,
    options,
    ...rest
  } = props;
  const locales = resolveBrowserLocale();
  const { roleLevel } = options;

  return (
    <List
      title={<Title />}
      // title={<PageTitle title={translate('resources.contributions.name', 2)} />}
      bulkActionButtons={false}
      perPage={paginationContributions}
      // title={<PageTitle title={translate('resources.contributions.name', 2)} />}
      {...props}
      pagination={<PostPagination />}
      actions={<ContributionsListActions />}
      filters={<ContributionsFilter translate={translate} />}
      sort={{ field: 'missionId' }}
      //pagination={null}
      style={{ display: 'grid' }}
    >
      <ContributionsComponent
        roleLevel={roleLevel}
        locales={locales}
        {...rest}
      />
    </List>
  );
};

// let ContributionsEdit = (props) => {
//   return (
//     <Edit>
//     <SimpleForm>
//       <TextInput source="name" />
//     </SimpleForm>
//     </Edit>
//   )
// }

ContributionsComponent = translate(ContributionsComponent);
ContributionsList = translate(ContributionsList);

//export { ContributionsList };

export default connect(
  null,
  {
    //  editContributionTime,
  }
)(ContributionsList);



// WEBPACK FOOTER //
// ./src/components/Contributions.js